export const PRODUCT_SEARCH = 'PRODUCT_SEARCH';
export const MENU_ITEMS = 'MENU_ITEMS';
export const ENABLE_SWITCH_ACCOUNT = 'ENABLE_SWITCH_ACCOUNT';
export const IS_MENU_CHECK = 'IS_MENU_CHECK';
export const IS_PRODUCT_SEARCH = 'IS_PRODUCT_SEARCH';
export const FORMATTED_MENU = 'FORMATTED_MENU';
export const ENABLE_SWITCH_ACCOUNT_DIALOG = 'ENABLE_SWITCH_ACCOUNT_DIALOG';
export const ACCEPT_CLEAR_POPUP = 'ACCEPT_CLEAR_POPUP';


const initialState = {
  searchHeader: false,
  menuItems: [],
  enableSwitchAccount: false,
  isMenuCheck: true,
  isProductSearch: false,
  enableSwitchAccountDialog: false,
  formattedMenu: '',
  acceptClearPopup: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_SEARCH: {
      return {
        ...state,
        searchHeader: action.payload,
      };
    }
    case IS_PRODUCT_SEARCH: {
      return {
        ...state,
        isProductSearch: action.payload,
      };
    }
    case MENU_ITEMS: {
      return {
        ...state,
        menuItems: action.payload,
      };
    }
    case ENABLE_SWITCH_ACCOUNT: {
      return {
        ...state,
        enableSwitchAccount: action.payload,
      };
    }
    case ENABLE_SWITCH_ACCOUNT_DIALOG: {
      return {
        ...state,
        enableSwitchAccountDialog: action.payload,
      };
    }
    case ACCEPT_CLEAR_POPUP: {
      return {
        ...state,
        acceptClearPopup: action.payload,
      };
    }
    case IS_MENU_CHECK: {
      return {
        ...state,
        isMenuCheck: action.payload,
      };
    }
    case FORMATTED_MENU: {
      return {
        ...state,
        formattedMenu: action.payload,
      };
    }
    default:
      return state;
  }
};

export const headerProductSearch = loader => ({
  type: PRODUCT_SEARCH,
  loader,
});

